<template>
  <section class="cv-card" aria-labelledby="cvcard-title">
    <div class="cv-ribbon">
      <div class="cv-ribbon__text">
        本日 <strong>{{ nowLabel }}</strong><br>今なら最短でご案内可能！
      </div>
    </div>

    <div class="cv-arrow">▼</div>

    <div class="cv-trust">
      <div class="cv-trust__card">
        <div class="cv-trust__logo-wrap">
          <img class="cv-trust__logo" src="../../assets/rank-table/vendor-6.png" :alt="vendorName" />
        </div>

        <div class="cv-trust__content">
          <ul class="cv-trust__bullets">
            <li><span class="check">✔ </span>最大82%OFFの<span class="bold-red">業界最安値級！</span></li>
            <li><span class="check">✔ </span>関西在住の方は<span class="bold-red">スグに駆けつけ</span></li>
            <li><span class="check">✔ </span>写真を送るだけで、<span class="bold-red">サクッと見積もり可能</span></li>
            <li><span class="check">✔ </span>見積もり後の<span class="bold-red">追加費用一切なし！</span></li>
            <li><span class="check">✔ </span>安心の<span class="bold-red">工事10年無料保証</span></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="cv-review" aria-label="ご利用者の声">
      <p class="cv-review__title">＼実際にご利用いただいたお客様の声／</p>

      <div class="cv-review__cards" role="list">
        <article v-for="(r, i) in visibleReviews" :key="'vis-' + i" class="cv-review__card" role="listitem">
          <img src="../../assets/google-review.png" alt="">
          <span class="cv-review__stars" :aria-label="r.aria">{{ r.stars }}</span>
          <p class="cv-review__text" v-html="r.text"></p>
          <p class="kutikom">※ 引用元：Google口コミ</p>
          <div class="cv-review__meta"></div>
        </article>
      </div>

      <transition name="cv-accord">
        <div v-show="showMore" class="cv-review__more-wrap">
          <div class="cv-review__cards" role="list">
            <article v-for="(r, i) in hiddenReviews" :key="'hid-' + i" class="cv-review__card" role="listitem">
              <img src="../../assets/google-review.png" alt="">
              <span class="cv-review__stars" :aria-label="r.aria">{{ r.stars }}</span>
              <p class="cv-review__text" v-html="r.text"></p>
              <p class="kutikom">※ 引用元：Google口コミ</p>
              <div class="cv-review__meta"></div>
            </article>
          </div>
        </div>
      </transition>

      <p class="cv-review__note">※ 個人の感想であり、対応時間は地域・状況により異なります。</p>
      <div v-if="hiddenCount > 0" class="cv-review__more-cta">
        <button type="button" class="cv-review__more-btn" :aria-expanded="showMore ? 'true' : 'false'"
          @click="toggleMore">
          <span v-if="!showMore">口コミをもっと見る（+{{ hiddenCount }}件）</span>
          <span v-else>閉じる</span>
        </button>
      </div>
    </div>

    <div class="cv-precta-band" role="note" aria-label="ご案内">
      <p class="nowLabel">本日<strong>{{ nowLabel }}</strong>時点<br>
        今なら<span class="under-yellow">空きがあり最短でご案内可能！</span></p>
      <img src="../../assets/table-1.png" alt="">
      <template v-if="timeBand === 'day'">
        <p class="notice-text">
          12月〜2月は給湯器の故障が特に多く、相談や見積もり依頼が集中するため、
          <span class="bold-red">当日や翌日の対応が難しくなるケースが増えます。</span><br>
        </p>
        <p>ただし、今ならまだ空きがあり、最短でのご案内が可能。</p>
        <p>
          もちろん、見積もり後に金額や内容に納得できなければ、
          <span class="bold-red">そのままキャンセルOK！</span>
        </p>
        <p>
        <strong>「まだどこの業者にするか悩んでる...」<br>
          「失敗したくないから慎重に選びたい…」</strong>
        </p>
        <p>
          そんな方も、見積もりを取っておけば
          比較の材料になるため、<span class="bold-red">空きがある今のうちにサクッと確認</span>しておくことをおすすめします。
        </p>
      </template>
    </div>

    <div class="cv-microcopy" aria-hidden="true">
      <span class="chip bold-font">＼最短で当日お湯が使えるようになる！／</span>
    </div>

    <div class="cv-bottom-cta">
      <a class="btn btn-primary pulse-btn" :href="affiliateLink" target="_blank" rel="nofollow noopener"
        aria-label="まずは無料相談してみる（新しいタブで開く）">
        電話一本で簡単！<br>まずは無料見積もりしてみる
      </a>
    </div>
  </section>
</template>

<script>
import { makeAffiliateUrl3 } from '../../utils/aff.js';
export default {
  name: "CVBoostCard",
  props: {
    vendorName: { type: String, default: "チカラもち" },
    vendorLogo: { type: String, required: true },
    personImg: { type: String, required: true },
    now: { type: Date, default: () => new Date() },
  },
  data() {
    return {
      nowInternal: this.now,
      timerId: null,
      showMore: false,
      reviews: [
        {
          text: "<strong>10社以上の業者から見積もりを取りましたが、その中でも「チカラもち」さんが際立っていました。</strong><br><br>価格はもちろんのこと、工事の手順や、導入に関するあらゆる不安材料について、非常に丁寧に、そして明確に説明してくださり、安心して契約することができました。<br><br>仕上がりも大変満足しています。<br><br><strong>数ある業者の中から「チカラもち」さんにお願いして本当に良かったと実感しています。</strong>",
          stars: "★★★★★",
        },
        {
          text: "寒いのにお湯が出なくて困り果て、取り付けてくれるところを探すも、年内の設置は無理とどこの業者さんからも言われてしまいました。<br><br>ところがチカラもちさんは、唯一年内設置OK！<br><br><strong>しかも安い！対応が早くて本当に助かりました。</strong><br><br>取り付けに来ていただいた方々もとても感じがよく、言うことなしです。ありがとうございました。",
          stars: "★★★★★",
        },
        {
          text: "設置担当の方は丁寧かつ親切で、本当に助かりました。<strong>ネットでの購入は不安でしたが、安心して任せると思います。</strong><br><br>値段も他の量販店なりよりかなり安く、おすすめです。実家の給湯器も考えます。",
          stars: "★★★★★",
        },
        {
          text: "<strong>急に壊れてお湯が出ず困っていた所、電話後にすぐ駆けつけてきてくれて、見積・交換も即対応でとても助かりました。</strong><br><br>工事の様子も非常に丁寧で、スタッフの方も対応よく、今後もチカラもちさんを使わせていただきたく思います。",
          stars: "★★★★★",
        },
        {
          text: "連絡したら当日来ていただき、すぐ取り付け工事をしてくださり助かりました。<br><br><strong>値段も一般家電量販店に比べてお安いと思います。</strong>",
          stars: "★★★★★",
        }
      ],
    };
  },
  computed: {
    nowLabel() {
      const d = this.nowInternal;
      const m = d.getMonth() + 1;
      const day = d.getDate();
      const hh = String(d.getHours()).padStart(2, "0");
      const mm = String(d.getMinutes()).padStart(2, "0");
      return `${m}月${day}日${hh}時${mm}分`;
    },
    visibleReviews() {
      return this.reviews.slice(0, 2);
    },
    hiddenReviews() {
      return this.reviews.slice(2);
    },
    hiddenCount() {
      return Math.max(this.reviews.length - 2, 0);
    },
    affiliateLink() {
      return makeAffiliateUrl3();
    },
    timeBand() {
      const h = this.nowInternal.getHours();
      if (h >= 5 && h < 19) return 'day';
      if (h >= 19 || h < 5) return 'day';
      return 'day';
    }
  },
  methods: {
    toggleMore() {
      this.showMore = !this.showMore;
    },
  },
  mounted() {
    this.timerId = setInterval(() => {
      this.nowInternal = new Date();
    }, 1000);
  },
  beforeUnmount() {
    if (this.timerId) clearInterval(this.timerId);
  },
};
</script>

<style scoped>
.cv-card {
  background: #f9f6da;
  max-width: 920px;
}

.cv-review__cards img {
  width: 30px;
  height: auto;
  display: inline-flex;
  vertical-align: middle;
  margin-right: 8px;
}

.limited-down-label {
  display: flex;
  justify-content: center;
  position: relative;
  margin: 0 auto 8px;
  margin-top: 30px;
}

.limited-down-label>span {
  display: inline-block;
  background: #e53935;
  color: #fff;
  font-weight: 900;
  font-size: 1.1rem;
  letter-spacing: .02em;
  padding: 8px 18px;
  position: relative;
}

.limited-down-label>span::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -10px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #e53935;
}

.campaign-banner {
  display: block;
  margin: 14px auto 6px;
  max-width: 820px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(0, 0, 0, .08);
  transition: transform .08s ease, box-shadow .2s ease;
}

.campaign-banner:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, .12);
}

.tyuui {
  font-size: 0.8rem;
  color: gray;
}

.campaign-banner img {
  display: block;
  width: 95%;
  height: auto;
  margin: 0 auto;
}

.campaign-caution {
  margin: 4px 0 12px;
  font-size: .9rem;
  text-align: left;
  color: #666;
  line-height: 1.5;
  width: 90%;
  margin: 0 auto;
  margin-bottom: 20px;
}

.cv-review__stars {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  line-height: 1;
  letter-spacing: .06em;
  font-weight: 700;
  padding: 2px 0;
  color: #ffc107;
}

.cv-ribbon {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: #d9534f;
  padding: 20px 16px;
  font-size: 1.2rem;
  font-weight: bold;
  color: #fff;
  line-height: 1.4;
}

.cv-ribbon__text {
  font-size: 1.4rem;
}

.cv-ribbon__text strong {
  font-size: 1.4rem;
  color: #f3d67f;
  font-weight: 900;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.cv-review__more-wrap {
  margin-top: 10px;
}

.kutikom {
  text-align: right;
  font-size: 0.7rem;
}

.cv-arrow {
  text-align: center;
  font-size: 3.4rem;
  color: #d9534f;
  font-weight: bold;
  margin-top: -40px;
  margin-bottom: 10px;
}

.cv-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: #fff9f1;
  border: 1px dashed #ffd9a6;
  border-radius: 12px;
  padding: 14px;
  margin-top: 12px;
}

.cv-precta-band img {
  width: 60%;
  margin: 0 auto;
  display: block;
}

.cv-hero__illust {
  width: 80%;
  margin-top: 20px;
}

.nozoku {
  font-size: 0.9rem;
  font-weight: 500;
}

.cv-trust {
  padding: 20px;
  padding-top: 0;
}

.nowLabel {
  text-align: center;
  font-size: 1.1rem;
}

.cv-trust__card {
  background: #fff;
  padding: 16px;
  display: flex;
  justify-content: space-evenly;
  border: 1px solid rgb(211, 208, 208);
}

.cv-trust__logo-wrap {
  flex: 0 0 35%;
  text-align: center;
}

.cv-trust__logo {
  width: 80%;
  height: auto;
  margin-bottom: 6px;
}

.cv-trust__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cv-trust__bullets {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 8px;
  font-weight: 600;
  color: #2b3a4a;
  line-height: 1.5;
}

.cv-microcopy {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.cv-trust__bullets {
  text-align: left;
}

.cv-microcopy .chip {
  font-size: .9rem;
  padding-bottom: 5px;
  font-weight: 600;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 12px 18px;
  border-radius: 4px;
  font-weight: 700;
}

.btn-primary {
  --btn-bg: #ff7a00;
  --btn-bg-dark: #e96e00;
  --btn-grad-top: #ffa043;
  --btn-shadow: 0 10px 24px rgba(233, 110, 0, .28);
  --btn-radius: 999px;
  color: #fff;
  background: linear-gradient(180deg, var(--btn-grad-top) 0%, var(--btn-bg) 40%, var(--btn-bg) 100%);
  border: 2px solid var(--btn-bg-dark);
  border-radius: var(--btn-radius);
  box-shadow: var(--btn-shadow);
  width: 100%;
  max-width: 640px;
  box-sizing: border-box;
  padding: 18px 24px;
  font-size: clamp(16px, 2.6vw, 20px);
  letter-spacing: .02em;
  line-height: 1.1;
  position: relative;
  isolation: isolate;
  overflow: hidden;
  transition: transform .08s ease, box-shadow .2s ease, filter .2s ease;
}

.btn-primary::before {
  content: "";
  position: absolute;
  top: 0;
  left: -80px;
  width: 60px;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .55) 50%, rgba(255, 255, 255, 0) 100%);
  transform: skewX(-20deg);
  animation: shine 4s infinite;
  pointer-events: none;
}

@keyframes shine {
  0% {
    left: -80px;
  }

  60% {
    left: 115%;
  }

  100% {
    left: 115%;
  }
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(233, 110, 0, .32);
  filter: brightness(1.02);
}

.btn-primary:active {
  transform: translateY(0);
  box-shadow: 0 8px 16px rgba(233, 110, 0, .22);
}

.btn-primary:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px #fff, 0 0 0 6px rgba(255, 122, 0, .9), var(--btn-shadow);
}

.cv-bottom-cta {
  text-align: center;
  padding-bottom: 30px;
}

.cv-bottom-cta .btn {
  width: 80%;
  max-width: 640px;
  padding: 18px 24px;
  font-size: clamp(16px, 2.6vw, 20px);
  box-sizing: border-box;
  font-weight: 800;
}

.pulse-btn {
  animation: pulse 1.6s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

@media (min-width: 481px) {
  .cv-trust__card {
    display: grid;
    grid-template-columns: 260px 1fr;
    grid-template-rows: auto auto;
    column-gap: 20px;
    row-gap: 6px;
    align-items: start;
  }

  .cv-trust__logo-wrap {
    grid-column: 1;
    grid-row: 1 / span 2;
    justify-self: center;
    align-self: start;
  }

  .cv-trust__logo {
    width: 85%;
    height: auto;
    margin: 0;
  }

  .cv-trust__title {
    grid-column: 2;
    grid-row: 1;
    margin: 35px 0 0;
    font-size: 1.6rem;
    line-height: 1.22;
    text-align: left;
  }

  .cv-trust__content {
    grid-column: 2;
    grid-row: 2;
    align-items: flex-start;
    margin-top: 0;
  }

  .cv-trust__bullets {
    margin: 0;
    width: 100%;
    gap: 6px;
  }

}

@media (max-width: 480px) {
  .cv-ribbon {
    padding: 30px 10px;
  }

  .cv-hero {
    flex-direction: column;
    text-align: center;
  }

  .cv-trust__card {
    flex-direction: column;
    text-align: center;
    border: 1px solid gray;
    border-radius: 10px;
    padding: 10px;
  }

  .cv-hero__illust {
    width: 90%;
  }

  .cv-trust__content {
    align-items: center;
  }

  .cv-microcopy {
    padding: 0 8px;
    gap: 6px;
  }

  .cv-microcopy .chip {
    font-size: .9rem;
    padding: 7px 9px;
  }

  .cv-bottom-cta .btn {
    width: 92%;
    max-width: none;
    font-size: 1.2rem;
  }

  h3 {
    font-size: 1.5rem;
    margin: 0 0 10px;
  }
}

@media (prefers-color-scheme: dark) {
  .btn-primary {
    filter: saturate(1.05) brightness(1.05);
  }
}

.cv-review {
  margin: 10px auto 16px;
  max-width: 820px;
  padding: 0 20px;
}

.cv-review__title {
  font-weight: 800;
  font-size: 1rem;
  color: #2b3a4a;
  margin: 6px 0 10px;
  text-align: center;
}

.cv-review__cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  text-align: left
}

.cv-review__card {
  background: #fff;
  border: 1px solid #e6e1c8;
  border-radius: 10px;
  padding: 12px 14px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .04);
}

.cv-review__text {
  margin: 0;
  font-size: .95rem;
  line-height: 1.6;
  color: #333;
}

.cv-review__meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  font-size: .85rem;
  color: #666;
}

.cv-review__user {
  white-space: nowrap;
}

.cv-review__note {
  margin: 6px 2px 0;
  font-size: .7rem;
  color: #777;
  text-align: left;
}

.cv-review__more-cta {
  text-align: center;
  margin-top: 10px;
}

.cv-review__more-btn {
  appearance: none;
  border: 1px solid #e6e1c8;
  background: #fff;
  padding: 10px 16px;
  border-radius: 999px;
  font-weight: 700;
  font-size: .95rem;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .04);
}

.cv-accord-enter-active,
.cv-accord-leave-active {
  transition: opacity .22s ease, transform .22s ease;
}

.cv-accord-enter-from,
.cv-accord-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.cv-review__text {
  margin-top: 20px;
}

.cv-trust__bullets {
  margin-bottom: 10px;
}

/* ===== SPのみ表示：cv-precta-band（BEMで隔離） ===== */
.cv-precta-band {
  display: none;
}

/* PC/タブレットは非表示 */

@media (max-width:480px) {
  .cv-precta-band {
    display: block;
    margin: 20px 20px 14px;
    padding: 10px 12px;
    background: #fcfcfc;
    /* 口コミカードと質感を変えるフラット帯 */
    border: 2px dashed #867f7f;
    /* 点線のみ。角丸・影なしで軽い */
    text-align: left;
  }

  .cv-precta-band__lead {
    margin: 0 0 4px;
    font-weight: 700;
    color: #2b3a4a;
    font-size: .96rem;
  }

  .cv-precta-band__sub {
    margin: 0;
    color: #4a4a4a;
    line-height: 1.6;
    font-size: .9rem;
  }

  .cv-precta-band__hl {
    display: inline-block;
    padding: 0 .35em;
    border-radius: 4px;
    background: #fff2c7;
    /* テキスト背面だけ軽く色付け */
  }

  .cv-precta-band__sp-br {
    display: inline;
  }
}

@media (min-width:481px) {
  .cv-precta-band__sp-br {
    display: none;
  }
}
</style>
